export const ACCESS_TOKEN = 'Access-Token'
export const PATIENT_USERID = 'patient_userId'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
